import EmployeeWorkInCalendarComponents from "../components/EmployeeWorkInCalendar";
import useEmployeeWorkInCalendar from "../hooks/useEmployeeWorkInCalendar";

function EmployeeWorkInCalendar({ employeeTeam, employeeName, isEmployee }) {
  const employeeWorkInCalendarProps = useEmployeeWorkInCalendar();
  return <EmployeeWorkInCalendarComponents
    {...employeeWorkInCalendarProps}
    employeeTeam={employeeTeam}
    employeeName={employeeName}
    isEmployee={isEmployee} />;
}

export default EmployeeWorkInCalendar;
